import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import BaseCom from './components/BaseCom';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import Layout from './components/Layout';
import Survey from './components/survey/Survey';

var router = null;

class AppRouter extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            user: null,
            loaded: true,
            connected: false
        };
    }

    render() {
        if (!this.state.loaded)
            return <></>;

        router = createBrowserRouter(createRoutesFromElements(
            <Route path="/" element={<Layout />}>
                <Route path="/f/:ident" element={<Survey />} />
                <Route path="/fill/:masterID" element={<Survey />} />
            </Route>
        ));
        return <RouterProvider router={router} />;
    }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <AppRouter />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
